import 'css-chunksrc/client/scenes/listRemoval/listsList/list/milestone/nameEditionForm/styles.scss';export default {
  "nameEditionForm": "_nameEditionForm_ozhvq_1",
  "form": "_form_ozhvq_6",
  "name": "_name_ozhvq_1",
  "icon": "_icon_ozhvq_27",
  "input": "_input_ozhvq_31",
  "edition": "_edition_ozhvq_52"
};